import Base64 from 'crypto-js/enc-base64';
import sha256 from 'crypto-js/sha256';

export const getCodeChallenge = (code_verifier: string) => {
  const base64Digest = Base64.stringify(sha256(code_verifier));
  return base64Digest.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
};

export const generateRandomString = (length: number) => {
  const text = Math.random().toString(36);
  return text.substring(0, length);
};
